import * as React from 'react';
import styled from 'styled-components';

import Actions_close from "./files/actions_close.svg";
import Actions_done from "./files/actions_done.svg";
import Actions_minus from "./files/actions_minus.svg";
import Actions_plus from "./files/actions_plus.svg";
import Actions_unavailable from "./files/actions_unavailable.svg";

import Add_Circle from "./files/add_circle.svg";
import Add_Circle_Fill from "./files/add_circle_fill.svg";

import Arrow_back from "./files/arrow_back.svg";

import Arrows_actions_fullscreen from "./files/arrows_actions_fullscreen.svg";
import Arrows_arrow_arrowBack from "./files/arrows_arrow_arrowBack.svg";
import Arrows_arrow_arrowDown from "./files/arrows_arrow_arrowDown.svg";
import Arrows_arrow_arrowForward from "./files/arrows_arrow_arrowForward.svg";
import Arrows_arrow_arrowUp from "./files/arrows_arrow_arrowUp.svg";

import Arrows_chevron_chevronBack from "./files/arrows_chevron_chevronBack.svg";
import Arrows_chevron_chevronDown from "./files/arrows_chevron_chevronDown.svg";
import Arrows_chevron_chevronForward from "./files/arrows_chevron_chevronForward.svg";
import Arrows_chevron_chevronUp from "./files/arrows_chevron_chevronUp.svg";

import Assignment from "./files/assignment_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";
import Assignment_late from "./files/assignment_late.svg";
import Assignment_turned_in from "./files/assignment_turned_in_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";

import Balance from "./files/balance_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";

import Bar_chart from "./files/bar_chart_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";

import Calendar from "./files/calendar.svg";
import Calendar_Check from "./files/calendar_check_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";
import Calendar_month from "./files/calendar_month_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";
import Cancel from "./files/cancel.svg";
import Cancel_Fill from "./files/cancel_fill.svg";
import Calendar_new from "./files/navigation_newCalendar.svg";

import Call_split from "./files/call_split_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";

import Captive_Portal from "./files/captive_portal_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";

import Caret_caretBack from "./files/caret_caretBack.svg";
import Caret_caretDown from "./files/caret_caretDown.svg";
import Caret_caretForward from "./files/caret_caretForward.svg";
import Caret_caretUp from "./files/caret_caretUp.svg";
import Caret_selector from "./files/caret_selector.svg";

import Check_box from "./files/check_box_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";
import Clock_arrow_up from "./files/clock_arrow_up.svg";
import Clock_loader from "./files/clock_loader_60_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";
import Chat_mark from "./files/mark_chat_read_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";
import Clock from "./files/navigation_clock.svg";

import Cloud_upload from "./files/cloud_upload.svg";

import Comment from "./files/comment_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";
import Comments_disabled from "./files/comments_disabled_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";
import Construction from "./files/construction.svg";

import Dashboard from "./files/dashboard_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";
import Data_charts_chart from "./files/data_charts_chart.svg";
import Data_files_document from "./files/data_files_document.svg";
import Data_files_file from "./files/data_files_file.svg";
import Data_files_folderClosed from "./files/data_files_folderClosed.svg";
import Data_files_folderCreate from "./files/data_files_folderCreate.svg";
import Data_files_folderOpen from "./files/data_files_folderOpen.svg";

import Data_sorting_alphabeticalAscending from "./files/data_sorting_alphabeticalAscending.svg";
import Data_sorting_alphabeticalDescending from "./files/data_sorting_alphabeticalDescending.svg";
import Data_sorting_numericAscending from "./files/data_sorting_numericAscending.svg";
import Data_sorting_numericDescending from "./files/data_sorting_numericDescending.svg";
import Data_sorting_sizeAscending from "./files/data_sorting_sizeAscending.svg";
import Data_sorting_sizeDescending from "./files/data_sorting_sizeDescending.svg";

import Developer_guide from "./files/developer_guide_24dp_434343_FILL0_wght400_GRAD0_opsz24.svg";

import Domino_mask from "./files/domino_mask_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";

import Drag_indicator from "./files/drag_indicator.svg";

import Emergency from "./files/e911_emergency_24dp_434343_FILL0_wght400_GRAD0_opsz24.svg";
import Earthquake from "./files/earthquake_24dp_434343_FILL0_wght400_GRAD0_opsz24.svg";
import Eco from "./files/eco.svg";
import Energy from "./files/energy.svg";
import Engineering from "./files/engineering_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";
import Event_list from './files/event_list_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg';
import Exclamation from "./files/exclamation.svg";

import Fact_check from "./files/fact_check.svg";
import Fact_check_thin from "./files/fact_check_24dp_5F6368_FILL0_wght200_GRAD0_opsz24.svg";

import Facility_bathRoom from "./files/facility_bathRoom.svg";
import Facility_canteen from "./files/facility_canteen.svg";
import Facility_cleaningRoom from "./files/facility_cleaningRoom.svg";
import Facility_cloakRoom from "./files/facility_cloakRoom.svg";
import Facility_domain from "./files/facility_domain.svg";
import Facility_entertainment from "./files/facility_entertainment.svg";
import Facilit_gym from "./files/facility_gym.svg";
import Facility_hallway from "./files/facility_hallway.svg";
import Facility_kitchen from "./files/facility_kitchen.svg";
import Facility_kitchenette from "./files/facility_kitchenette.svg";
import Facility_meetingRoom from "./files/facility_meetingRoom.svg";
import Facility_other from "./files/facility_other.svg";
import Facility_physicalTherapy from "./files/facility_physicalTherapy.svg";
import Facility_reception from "./files/facility_reception.svg";
import Facility_relaxationRoom from "./files/facility_relaxationRoom.svg";
import Facility_restRoom from "./files/facility_restRoom.svg";
import Facility_serverRoom from "./files/facility_serverRoom.svg";
import Facility_storageRoom from "./files/facility_storageRoom.svg";
import Fast_forward from "./files/fast_forward.svg";
import Fast_rewind from "./files/fast_rewind.svg";

import File from "./files/file.svg";
import File_csv from "./files/file_csv.svg";
import File_excel from "./files/file_excel.svg";
import File_film from "./files/file_film.svg";
import File_image from "./files/file_image.svg";
import File_pdf from "./files/file_pdf.svg";
import File_text from "./files/file_text.svg";
import File_word from "./files/file_word.svg";

import Falling from "./files/falling_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";
import FireTruck from "./files/fire_truck.svg";
import Forum from "./files/forum_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";
import Frame_inspect from "./files/frame_inspect_24dp_5F6368_FILL0_wght200_GRAD0_opsz24.svg";

import Gavel from "./files/gavel.svg";
import Globe from "./files/globe_24dp_434343_FILL0_wght300_GRAD0_opsz24.svg";
import Graph from "./files/graph_2_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";

import Handshake from "./files/handshake_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";
import Heart_heartFilled from "./files/heart_heartFilled.svg";
import Heart_heartOutlined from "./files/heart_heartOutlined.svg";
import Help from "./files/help_24dp_434343_FILL0_wght200_GRAD0_opsz24.svg";
import HorizontalRule from "./files/horizontal_rule_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";

import Interface_actions_attach from "./files/interface_actions_attach.svg";
import Interface_actions_bookmark from "./files/interface_actions_bookmark.svg";
import Interface_actions_copy from "./files/interface_actions_copy.svg";
import Interface_actions_delete from "./files/interface_actions_delete.svg";
import Interface_actions_dislike from "./files/interface_actions_dislike.svg";
import Interface_actions_download from "./files/interface_actions_download.svg";
import Interface_actions_edit from "./files/interface_actions_edit.svg";
import Interface_actions_externalLink from "./files/interface_actions_externalLink.svg";
import Interface_actions_filter from "./files/interface_actions_filter.svg";
import Interface_actions_hidden from "./files/interface_actions_hidden.svg";
import Interface_actions_like from "./files/interface_actions_like.svg";
import Interface_actions_link from "./files/interface_actions_link.svg";
import Interface_actions_linkBreak from "./files/interface_actions_linkBreak.svg";
import Interface_actions_mail from "./files/interface_actions_mail.svg";
import Interface_actions_notificationOff from "./files/interface_actions_notificationOff.svg";
import Interface_actions_notificationOn from "./files/interface_actions_notificationOn.svg";
import Interface_actions_print from "./files/interface_actions_print.svg";
import Interface_actions_save from "./files/interface_actions_save.svg";
import Interface_actions_search from "./files/interface_actions_search.svg";
import Interface_actions_send from "./files/interface_actions_send.svg";
import Interface_actions_share from "./files/interface_actions_share.svg";
import Interface_actions_synchronize from "./files/interface_actions_synchronize.svg";
import Interface_actions_view from "./files/interface_actions_view.svg";
import Interface_actions_share_off from "./files/share_off_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";

import Interface_glyph_checked from "./files/interface_glyph_checked.svg";
import Interface_glyph_comment from "./files/interface_glyph_comment.svg";
import Interface_glyph_email from "./files/Interface_glyph_email.svg";
import Interface_glyph_hourglass from "./files/interface_glyph_hourglass.svg";
import Interface_glyph_location from "./files/interface_glyph_location.svg";
import Interface_glyph_location_chip from "./files/interface_glyph_location_chip.svg";
import Interface_glyph_percent from "./files/interface_glyph_percent.svg";
import Interface_glyph_phone from "./files/interface_glyph_phone.svg";

import Interface_user_account from "./files/interface_user_account.svg";
import Interface_user_addUser from "./files/interface_user_addUser.svg";
import Interface_user_team from "./files/interface_user_team.svg";
import Interface_user_user from "./files/interface_user_user.svg";
import Interface_user_userOK from "./files/interface_user_userOK.svg";
import Interface_user_users from "./files/interface_user_users.svg";

import Keyboard_double_arrowLeft from "./files/keyboard_double_arrow_left_24dp_5F6368_FILL0_wght400_GRAD0_opsz24.svg";
import Keyboard_double_arrowRight from "./files/keyboard_double_arrow_right_24dp_5F6368_FILL0_wght400_GRAD0_opsz24.svg";

import Learning_emotionalIntelligence from "./files/psychiatry_48dp_434343_FILL0_wght400_GRAD0_opsz48.svg";
import Learning_psychologicalSafety from "./files/relax_48dp_434343_FILL0_wght400_GRAD0_opsz48.svg";
import Learning_stress from "./files/sentiment_stressed_48dp_434343_FILL0_wght400_GRAD0_opsz48.svg";
import Learning_conflict from "./files/sword_rose_48dp_434343_FILL0_wght400_GRAD0_opsz48.svg";

import Language from "./files/language_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";

import List from "./files/list_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";
import List_alt from "./files/list_alt_24dp_434343_FILL0_wght400_GRAD0_opsz24.svg";
import List_alt_check from "./files/list_alt_check_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";

import Login from "./files/login.svg";
import Logout from "./files/logout.svg";

import Lock from "./files/lock_24dp_434343_FILL0_wght400_GRAD0_opsz24.svg";
import Lock_open from "./files/lock_open_24dp_434343_FILL0_wght400_GRAD0_opsz24.svg";

import Missing from "./files/gpp_bad_FILL1_wght400_GRAD0_opsz48.svg";
import Mail_off from "./files/mail_off_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";
import Manufacturing from "./files/manufacturing_24dp_434343_FILL0_wght400_GRAD0_opsz24.svg";
import More_horiz from "./files/more_horiz_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";

import Nature_people from "./files/nature_people_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";


import Navigation_menu from "./files/menu_24dp_434343_FILL0_wght400_GRAD0_opsz48.svg";

import Navigation_context from "./files/navigation_context.svg";
import Navigation_home from "./files/navigation_home.svg";
import Navigation_homeSelected from "./files/navigation_homeSelected.svg";
import Navigation_inbox from "./files/navigation_inbox.svg";
import Navigation_map from "./files/navigation_map.svg";
import Navigation_preferences from "./files/navigation_preferences.svg";
import Navigation_settings from "./files/navigation_settings.svg";

import Notes from "./files/notes_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";

import PersonalInjury from './files/personal_injury_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg';
import PhotoLibrary from "./files/photo_library.svg";
import PhotoLibraryThin from "./files/photo_library_24dp_E8EAED_FILL0_wght300_GRAD0_opsz24.svg";
import PhysicalTherapy from "./files/physical_therapy.svg";
import Play_arrow from "./files/play_arrow.svg";
import Policy from "./files/policy.svg";
import Priority from "./files/priority.svg";

import Quiz from "./files/quiz_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";

import Radio_button_checked from "./files/radio_button_checked_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";

import Record_voice_over from "./files/record_voice_over_24dp_434343_FILL0_wght400_GRAD0_opsz24.svg";
import Report from "./files/report_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";
import Rule from "./files/rule_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";

import School from "./files/school.svg";

import Security from "./files/security_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";
import Shield from "./files/shield_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";
import SmartDisplay from "./files/smart_display.svg";

import Support from "./files/support_agent_24dp_434343_FILL0_wght300_GRAD0_opsz24.svg";

import Survey_indicator from "./files/survey_indicator.svg";
import Survey_mood_bad from "./files/survey_mood_bad.svg";
import Survey_mood_good from "./files/survey_mood_good.svg";
import Survey_mood_neutral from "./files/survey_mood_neutral.svg";
import Survey_mood_veryBad from "./files/survey_mood_veryBad.svg";
import Survey_mood_veryGood from "./files/survey_mood_veryGood.svg";
import Survey_question from "./files/survey_question.svg";

import Stacks from "./files/stacks_24dp_434343_FILL0_wght400_GRAD0_opsz24.svg";

import Star_starFilled from "./files/star_starFilled.svg";
import Star_starOutlined from "./files/star_starOutlined.svg";

import Status_empty from "./files/status_empty.svg";
import Status_error from "./files/status_error.svg";
import Status_ok from "./files/status_ok.svg";

import Table from "./files/table.svg";
import Tags_newTag from "./files/tags_newTag.svg";
import Tags_tag from "./files/tags_tag.svg";
import Tags_tags from "./files/tags_tags.svg";
import Target from "./files/target_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";
import Thumbs_up_down from "./files/thumbs_up_down.svg";
import Toggle_on from "./files/toggle_on.svg";

import Umbrella from "./files/beach_access_24dp_434343_FILL0_wght400_GRAD0_opsz24.svg";

import Verified_user from "./files/verified_user_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";
import Warning from "./files/warning.svg";

import Facility_elevator from "./files/elevator_24dp_5F6368_FILL0_wght400_GRAD0_opsz24.svg";
import Facility_boiler_room from "./files/heat_24dp_5F6368_FILL0_wght400_GRAD0_opsz24.svg";
import Facility_production from "./files/precision_manufacturing_24dp_5F6368_FILL0_wght400_GRAD0_opsz24.svg";
import Facility_stairs from "./files/stairs_2_24dp_5F6368_FILL0_wght400_GRAD0_opsz24.svg";
import Facility_heat_exchanger_room from "./files/water_pump_24dp_5F6368_FILL0_wght400_GRAD0_opsz24.svg";

import Wand_stars from "./files/wand_stars_24dp_E3E3E3_FILL0_wght400_GRAD0_opsz24.svg";

import { colors } from '../colors/color';
import { TooltipWrapper } from '../TooltipWrapper';



export type iconName = typeof iconNames[number];

export const iconNames = [
    'actions_close',
    'actions_done',
    'actions_minus',
    'actions_plus',
    'actions_unavailable',
    'add_circle',
    'add_circle_fill',
    'arrow_back',
    'arrows_actions_fullscreen',
    'arrows_arrow_arrowBack',
    'arrows_arrow_arrowDown',
    'arrows_arrow_arrowForward',
    'arrows_arrow_arrowUp',
    'arrows_chevron_chevronBack',
    'arrows_chevron_chevronDown',
    'arrows_chevron_chevronForward',
    'arrows_chevron_chevronUp',
    'assignment',
    'assignment_late',
    'assignment_turned_in',
    'balance',
    'bar_chart',
    'calendar',
    'calendar_month',
    'calendar_new',
    'calendar_check',
    'call_split',
    'cancel',
    'cancel_fill',
    'captive_portal',
    'caret_caretBack',
    'caret_caretDown',
    'caret_caretForward',
    'caret_caretUp',
    'caret_selector',
    'chat_mark',
    'check_box',
    'clock',
    'clock_loader',
    'clock_arrow_up',
    'cloud_upload',
    'comment',
    'comments_disabled',
    'construction',
    'dashboard',
    'data_charts_chart',
    'data_files_document',
    'data_files_file',
    'data_files_folderClosed',
    'data_files_folderCreate',
    'data_files_folderOpen',
    'data_sorting_alphabeticalAscending',
    'data_sorting_alphabeticalDescending',
    'data_sorting_numericAscending',
    'data_sorting_numericDescending',
    'data_sorting_sizeAscending',
    'data_sorting_sizeDescending',
    'developer_guide',
    'domino_mask',
    'drag_indicator',
    'earthquake',
    'eco',
    'emergency',
    'engineering',
    'energy',
    'event_list',
    'exclamation',
    'fact_check',
    'fact_check_thin',
    'facility_bathRoom',
    'facility_canteen',
    'facility_cleaningRoom',
    'facility_cloakRoom',
    'facility_domain',
    'facility_entertainment',
    'facility_gym',
    'facility_hallway',
    'facility_kitchen',
    'facility_kitchenette',
    'facility_meetingRoom',
    'facility_other',
    'facility_physicalTherapy',
    'facility_reception',
    'facility_relaxationRoom',
    'facility_restRoom',
    'facility_serverRoom',
    'facility_storageRoom',
    'falling',
    'fast_forward',
    'fast_rewind',
    'file_csv',
    'file_excel',
    'file_film',
    'file_image',
    'file_pdf',
    'file_text',
    'file_word',
    'file',
    'fire_truck',
    'forum',
    'frame_inspect',
    'gavel',
    'globe',
    'graph',
    'handshake',
    'heart_heartFilled',
    'heart_heartOutlined',
    'help',
    'horizontal_rule',
    'interface_actions_edit',
    'interface_actions_delete',
    'interface_actions_synchronize',
    'interface_actions_attach',
    'interface_actions_externalLink',
    'interface_actions_copy',
    'interface_actions_bookmark',
    'interface_actions_mail',
    'interface_actions_notificationOn',
    'interface_actions_notificationOff',
    'interface_actions_view',
    'interface_actions_hidden',
    'interface_actions_filter',
    'interface_actions_share',
    'interface_actions_share_off',
    'interface_actions_search',
    'interface_actions_send',
    'interface_actions_save',
    'interface_actions_download',
    'interface_actions_link',
    'interface_actions_linkBreak',
    'interface_actions_like',
    'interface_actions_dislike',
    'interface_actions_print',
    'interface_glyph_checked',
    'interface_glyph_comment',
    'interface_glyph_email',
    'interface_glyph_hourglass',
    'interface_glyph_location',
    'interface_glyph_location_chip',
    'interface_glyph_phone',
    'interface_glyph_percent',
    'interface_user_account',
    'interface_user_addUser',
    'interface_user_team',
    'interface_user_user',
    'interface_user_userOK',
    'interface_user_users',
    'keyboard_double_arrowLeft',
    'keyboard_double_arrowRight',
    'learning_conflict',
    'language',
    'learning_emotionalIntelligence',
    'learning_psychologicalSafety',
    'learning_stress',
    'list',
    'list_alt',
    'list_alt_check',
    'login',
    'logout',
    'lock',
    'lock_open',
    'mail_off',
    'manufacturing',
    'more_horiz',
    'nature_people',
    'navigation_context',
    'navigation_home',
    'navigation_homeSelected',
    'navigation_inbox',
    'navigation_map',
    'navigation_menu',
    'navigation_preferences',
    'navigation_settings',
    'notes',
    'personal_injury',
    'photo_library',
    'photo_library_thin',
    'physical_therapy',
    'play_arrow',
    'policy',
    'priority',
    'quiz',
    'radio_button_checked',
    'record_voice_over',
    'report',
    'rule',
    'school',
    'security',
    'shield',
    'smart_display',
    'support',
    'survey_indicator',
    'survey_mood_bad',
    'survey_mood_good',
    'survey_mood_neutral',
    'survey_mood_veryBad',
    'survey_mood_veryGood',
    'survey_question',
    'stacks',
    'star_starFilled',
    'star_starOutlined',
    'status_empty',
    'status_ok',
    'status_error',
    'table',
    'tags_newTag',
    'tags_tag',
    'tags_tags',
    'target',
    'thumbs_up_down',
    'toggle_on',
    'umbrella',
    'missing',
    'facility_stairs',
    'facility_elevator',
    'facility_production',
    'facility_boiler_room',
    'facility_heat_exchanger_room',
    'verified_user',
    'wand_stars',
    'warning'
] as const;

export const getIconSvg = (iconName: iconName) =>
{

    switch (iconName)
    {
        case "actions_close":
            return <Actions_close />;
        case "add_circle":
            return <Add_Circle />;
        case "add_circle_fill":
            return <Add_Circle_Fill />;
        case "actions_done":
            return <Actions_done />;
        case "actions_minus":
            return <Actions_minus />;
        case "actions_plus":
            return <Actions_plus />;
        case "actions_unavailable":
            return <Actions_unavailable />;
        case "arrow_back":
            return <Arrow_back />;
        case "arrows_actions_fullscreen":
            return <Arrows_actions_fullscreen />;
        case "arrows_arrow_arrowBack":
            return <Arrows_arrow_arrowBack />;
        case "arrows_arrow_arrowDown":
            return <Arrows_arrow_arrowDown />;
        case "arrows_arrow_arrowForward":
            return <Arrows_arrow_arrowForward />;
        case "arrows_arrow_arrowUp":
            return <Arrows_arrow_arrowUp />;
        case "arrows_chevron_chevronBack":
            return <Arrows_chevron_chevronBack />;
        case "arrows_chevron_chevronDown":
            return <Arrows_chevron_chevronDown />;
        case "arrows_chevron_chevronForward":
            return <Arrows_chevron_chevronForward />;
        case "arrows_chevron_chevronUp":
            return <Arrows_chevron_chevronUp />;
        case "assignment":
            return <Assignment />;
        case "assignment_late":
            return <Assignment_late />;
        case "assignment_turned_in":
            return <Assignment_turned_in />;
        case "balance":
            return <Balance />;
        case "calendar_month":
            return <Calendar_month />;
        case "bar_chart":
            return <Bar_chart />;
        case "calendar_check":
            return <Calendar_Check />;
        case "call_split":
            return <Call_split />;
        case "cancel":
            return <Cancel />;
        case "cancel_fill":
            return <Cancel_Fill />;
        case "captive_portal":
            return <Captive_Portal />;
        case "caret_caretBack":
            return <Caret_caretBack />;
        case "caret_caretDown":
            return <Caret_caretDown />;
        case "caret_caretForward":
            return <Caret_caretForward />;
        case "caret_caretUp":
            return <Caret_caretUp />;
        case "caret_selector":
            return <Caret_selector />;
        case "chat_mark":
            return <Chat_mark />;
        case "check_box":
            return <Check_box />;
        case "clock_arrow_up":
            return <Clock_arrow_up />;
        case "clock_loader":
            return <Clock_loader />;
        case "cloud_upload":
            return <Cloud_upload />;
        case "comment":
            return <Comment />;
        case "comments_disabled":
            return <Comments_disabled />;
        case "construction":
            return <Construction />;
        case "dashboard":
            return <Dashboard />;
        case "developer_guide":
            return <Developer_guide />;
        case "domino_mask":
            return <Domino_mask />;
        case "drag_indicator":
            return <Drag_indicator />;
        case "earthquake":
            return <Earthquake />;
        case "eco":
            return <Eco />;
        case "emergency":
            return <Emergency />;
        case "engineering":
            return <Engineering />;
        case "energy":
            return <Energy />;
        case "data_charts_chart":
            return <Data_charts_chart />;
        case "fact_check":
            return <Fact_check />;
        case "fact_check_thin":
            return <Fact_check_thin />;
        case "facility_bathRoom":
            return <Facility_bathRoom />;
        case "facility_canteen":
            return <Facility_canteen />;
        case "facility_cleaningRoom":
            return <Facility_cleaningRoom />;
        case "facility_cloakRoom":
            return <Facility_cloakRoom />;
        case "facility_domain":
            return <Facility_domain />;
        case "facility_entertainment":
            return <Facility_entertainment />;
        case "facility_gym":
            return <Facilit_gym />;
        case "facility_hallway":
            return <Facility_hallway />;
        case "facility_kitchen":
            return <Facility_kitchen />;
        case "facility_kitchenette":
            return <Facility_kitchenette />;
        case "facility_meetingRoom":
            return <Facility_meetingRoom />;
        case "facility_other":
            return <Facility_other />;
        case "facility_physicalTherapy":
            return <Facility_physicalTherapy />;
        case "facility_reception":
            return <Facility_reception />;
        case "facility_relaxationRoom":
            return <Facility_relaxationRoom />;
        case "facility_restRoom":
            return <Facility_restRoom />;
        case "facility_serverRoom":
            return <Facility_serverRoom />;
        case "facility_storageRoom":
            return <Facility_storageRoom />;
        case "falling":
            return <Falling />;
        case "fast_forward":
            return <Fast_forward />;
        case "fast_rewind":
            return <Fast_rewind />;
        case "file_csv":
            return <File_csv />;
        case "file_excel":
            return <File_excel />;
        case "file_film":
            return <File_film />;
        case "file_image":
            return <File_image />;
        case "file_pdf":
            return <File_pdf />;
        case "file_text":
            return <File_text />;
        case "file_word":
            return <File_word />;
        case "file":
            return <File />;
        case "fire_truck":
            return <FireTruck />;
        case "forum":
            return <Forum />;
        case "frame_inspect":
            return <Frame_inspect />;
        case "gavel":
            return <Gavel />;
        case "globe":
            return <Globe />;
        case "graph":
            return <Graph />;
        case 'horizontal_rule':
            return <HorizontalRule />;
        case "data_files_document":
            return <Data_files_document />;
        case "data_files_file":
            return <Data_files_file />;
        case "data_files_folderClosed":
            return <Data_files_folderClosed />;
        case "data_files_folderCreate":
            return <Data_files_folderCreate />;
        case "data_files_folderOpen":
            return <Data_files_folderOpen />;
        case "data_sorting_alphabeticalAscending":
            return <Data_sorting_alphabeticalAscending />;
        case "data_sorting_alphabeticalDescending":
            return <Data_sorting_alphabeticalDescending />;
        case "data_sorting_numericAscending":
            return <Data_sorting_numericAscending />;
        case "data_sorting_numericDescending":
            return <Data_sorting_numericDescending />;
        case "data_sorting_sizeAscending":
            return <Data_sorting_sizeAscending />;
        case "data_sorting_sizeDescending":
            return <Data_sorting_sizeDescending />;
        case "event_list":
            return <Event_list />;
        case "exclamation":
            return <Exclamation />;
        case "handshake":
            return <Handshake />;
        case "heart_heartFilled":
            return <Heart_heartFilled />;
        case "heart_heartOutlined":
            return <Heart_heartOutlined />;
        case "help":
            return <Help />;
        case "interface_actions_edit":
            return <Interface_actions_edit />;
        case "interface_actions_delete":
            return <Interface_actions_delete />;
        case "interface_actions_synchronize":
            return <Interface_actions_synchronize />;
        case "interface_actions_attach":
            return <Interface_actions_attach />;
        case "interface_actions_externalLink":
            return <Interface_actions_externalLink />;
        case "interface_actions_copy":
            return <Interface_actions_copy />;
        case "interface_actions_bookmark":
            return <Interface_actions_bookmark />;
        case "interface_actions_mail":
            return <Interface_actions_mail />;
        case "interface_actions_notificationOn":
            return <Interface_actions_notificationOn />;
        case "interface_actions_notificationOff":
            return <Interface_actions_notificationOff />;
        case "interface_actions_view":
            return <Interface_actions_view />;
        case "interface_actions_hidden":
            return <Interface_actions_hidden />;
        case "interface_actions_filter":
            return <Interface_actions_filter />;
        case "interface_actions_share":
            return <Interface_actions_share />;
        case "interface_actions_share_off":
            return <Interface_actions_share_off />;
        case "interface_actions_search":
            return <Interface_actions_search />;
        case "interface_actions_send":
            return <Interface_actions_send />;
        case "interface_actions_save":
            return <Interface_actions_save />;
        case "interface_actions_download":
            return <Interface_actions_download />;
        case "interface_actions_link":
            return <Interface_actions_link />;
        case "interface_actions_linkBreak":
            return <Interface_actions_linkBreak />;
        case "interface_actions_like":
            return <Interface_actions_like />;
        case "interface_actions_dislike":
            return <Interface_actions_dislike />;
        case "interface_actions_print":
            return <Interface_actions_print />;
        case "interface_glyph_checked":
            return <Interface_glyph_checked />;
        case "interface_glyph_comment":
            return <Interface_glyph_comment />;
        case "interface_glyph_email":
            return <Interface_glyph_email />;
        case "interface_glyph_hourglass":
            return <Interface_glyph_hourglass />;
        case "interface_glyph_location":
            return <Interface_glyph_location />;
        case "interface_glyph_location_chip":
            return <Interface_glyph_location_chip />;
        case "interface_glyph_phone":
            return <Interface_glyph_phone />;
        case "interface_glyph_percent":
            return <Interface_glyph_percent />;
        case "interface_user_account":
            return <Interface_user_account />;
        case "interface_user_addUser":
            return <Interface_user_addUser />;
        case "interface_user_team":
            return <Interface_user_team />;
        case "interface_user_user":
            return <Interface_user_user />;
        case "interface_user_userOK":
            return <Interface_user_userOK />;
        case "interface_user_users":
            return <Interface_user_users />;
        case "keyboard_double_arrowLeft":
            return <Keyboard_double_arrowLeft />;
        case "keyboard_double_arrowRight":
            return <Keyboard_double_arrowRight />;
        case "language":
            return <Language />;
        case "learning_conflict":
            return <Learning_conflict />;
        case "learning_emotionalIntelligence":
            return <Learning_emotionalIntelligence />;
        case "learning_psychologicalSafety":
            return <Learning_psychologicalSafety />;
        case "learning_stress":
            return <Learning_stress />;
        case "list":
            return <List />;
        case "list_alt":
            return <List_alt />;
        case "list_alt_check":
            return <List_alt_check />;
        case "login":
            return <Login />;
        case "logout":
            return <Logout />;
        case "lock":
            return <Lock />;
        case "lock_open":
            return <Lock_open />;
        case "mail_off":
            return <Mail_off />;
        case "manufacturing":
            return <Manufacturing />;
        case "more_horiz":
            return <More_horiz />;
        case "nature_people":
            return <Nature_people />;
        case "calendar":
            return <Calendar />;
        case "clock":
            return <Clock />;
        case "navigation_context":
            return <Navigation_context />;
        case "navigation_home":
            return <Navigation_home />;
        case "navigation_homeSelected":
            return <Navigation_homeSelected />;
        case "navigation_inbox":
            return <Navigation_inbox />;
        case "navigation_map":
            return <Navigation_map />;
        case "navigation_menu":
            return <Navigation_menu />;
        case "notes":
            return <Notes />;
        case "calendar_new":
            return <Calendar_new />;
        case "navigation_preferences":
            return <Navigation_preferences />;
        case "navigation_settings":
            return <Navigation_settings />;
        case "personal_injury":
            return <PersonalInjury />;
        case "photo_library":
            return <PhotoLibrary />;
        case "photo_library_thin":
            return <PhotoLibraryThin />;
        case 'physical_therapy':
            return <PhysicalTherapy />;
        case "play_arrow":
            return <Play_arrow />;
        case "policy":
            return <Policy />;
        case "priority":
            return <Priority />;
        case "quiz":
            return <Quiz />;
        case "radio_button_checked":
            return <Radio_button_checked />;
        case "record_voice_over":
            return <Record_voice_over />;
        case "report":
            return <Report />;
        case "rule":
            return <Rule />;
        case "school":
            return <School />;
        case "security":
            return <Security />;
        case "shield":
            return <Shield />;
        case "smart_display":
            return <SmartDisplay />;
        case "support":
            return <Support />;
        case "survey_indicator":
            return <Survey_indicator />;
        case "survey_mood_bad":
            return <Survey_mood_bad />;
        case "survey_mood_good":
            return <Survey_mood_good />;
        case "survey_mood_neutral":
            return <Survey_mood_neutral />;
        case "survey_mood_veryBad":
            return <Survey_mood_veryBad />;
        case "survey_mood_veryGood":
            return <Survey_mood_veryGood />;
        case "survey_question":
            return <Survey_question />;
        case "stacks":
            return <Stacks />;
        case "star_starFilled":
            return <Star_starFilled />;
        case "star_starOutlined":
            return <Star_starOutlined />;
        case "status_empty":
            return <Status_empty />;
        case "status_ok":
            return <Status_ok />;
        case "status_error":
            return <Status_error />;
        case "table":
            return <Table />;
        case "tags_newTag":
            return <Tags_newTag />;
        case "tags_tag":
            return <Tags_tag />;
        case "tags_tags":
            return <Tags_tags />;
        case "target":
            return <Target />;
        case "thumbs_up_down":
            return <Thumbs_up_down />;
        case "toggle_on":
            return <Toggle_on />;
        case "umbrella":
            return <Umbrella />;
        case "verified_user":
            return <Verified_user />;
        case "wand_stars":
            return <Wand_stars />;
        case "warning":
            return <Warning />;
        case "facility_elevator":
            return <Facility_elevator />;
        case "facility_stairs":
            return <Facility_stairs />;
        case "facility_production":
            return <Facility_production />;
        case "facility_boiler_room":
            return <Facility_boiler_room />;
        case "facility_heat_exchanger_room":
            return <Facility_heat_exchanger_room />;
        

        default:
            return <Missing />;
    }
};

export const IconSizes = ['xx-small', 'x-small', 'small', 'medium', 'large'] as const;

export type IconSize = typeof IconSizes[number];


const handleIconSize = (iconsize?: IconSize) =>
{
    switch (iconsize)
    {
        case "xx-small":
            return 10;
        case "x-small":
            return 16;
        case "small":
            return 24;
        case "medium":
            return 36;
        case "large":
            return 72;
        default:
            return 24;
    }
};

function borderIcon ()
{
    return "border: 1px solid gray; border-radius: 50%;";
}



const IconFrame = styled.div<{ svgColor?:string, dim:number, border?:boolean, hidden?:boolean; }>`
    
    ${props => props.border && borderIcon()}
    display: grid;
    align-items: center;
    justify-content: center;
    width: ${props => props.dim}px;
    height: ${props => props.dim}px;
    
    transition: all 0.2s ease-in;

    ${props => (props.hidden) &&
        'visibility:hidden;'
    }

    svg {
        fill: ${props => props.svgColor || colors.icon.default};
        height: ${props => props.dim}px;
        width: ${props => props.dim}px;
    }
`;


export type IconProps = {
    border?: boolean;
    color?: string;
    name: iconName;
    size?: IconSize;
    sizeOverride?: number;
    hidden?: boolean;
    toolTipText?: string;
};

export const Icon: React.FC<IconProps> = ({ color, name, size, border, sizeOverride, hidden, toolTipText }) => 
{
    const dim = sizeOverride || handleIconSize(size);

    const icon = 
        <IconFrame svgColor={color} dim={dim} border={border} hidden={hidden} className="icon">
            {getIconSvg(name)}
        </IconFrame>

    return (
    <>
        {toolTipText
            ?   <TooltipWrapper wrapper="div"
                    tooltip={<span>{toolTipText}</span>}>
                    {icon}
                </TooltipWrapper>
            : icon
        }
    </>
    );
};